import React, { useEffect, useState } from 'react';
import MuiDrawer from '@mui/material/SwipeableDrawer';
import Grid from '@mui/material/Grid';
import { List } from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowLeftSharpIcon from '@mui/icons-material/KeyboardDoubleArrowLeftSharp';
import KeyboardDoubleArrowRightSharpIcon from '@mui/icons-material/KeyboardDoubleArrowRightSharp';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CollapsibleMenu from '../menu/CollapsibleMenu';
import StyledSiteLogoAndName from '../logo/StyledSiteLogoAndName';
import ListItem from './Listitem';

import { BUILD_VERSION } from '../../constants';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.textColor,
  fontWeight: 'bold'
}));

const openedMixin = (theme, drawerwidth) => ({
  width: drawerwidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden'
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`
  }
});

const StyledDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '64px',
  minHeight: '64px',
  padding: theme.spacing(0, 0),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}));

const StyledDrawer = styled(MuiDrawer)(({ theme, open, drawerwidth }) => ({
  width: drawerwidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme, drawerwidth),
    '& .MuiDrawer-paper': openedMixin(theme, drawerwidth)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

const StyledMenu = styled('div')(() => ({
  height: '85vh',
  overflowY: 'auto',
  overflowX: 'hidden',
  backgroundColor: 'white'
}));

export default function SideDrawer(props) {
  // console.log(props, "these are props inside drawer")
  const {
    variant,
    data,
    isDark,
    theme,
    userData,
    drawerWidth,
    setSidebar,
    isSidebarOpen,
    setIsSidebarOpen,
    handleDrawerOpen,
    handleDrawerClose
  } = props;

  console.log('isSidebarOpen in sidedrawerpage', isSidebarOpen);

  useEffect(() => {
    // console.log(variant, "this is sidebar variant")
    userData && setIsSidebarOpen(userData.preferences?.sidebar || true);
    setSidebar(variant);
  }, []);

  /**
   * Added function to trigger the resize functionality of the chart
   * on the sidebar value change(On collapse/ expand button click)
   */
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }, [isSidebarOpen]);

  // useEffect(() => {
  //     console.log('userData.preferences?.sidebar    :', userData && userData.preferences?.sidebar || true);
  //     userData && setIsSidebarOpen(userData.preferences?.sidebar || true)
  // }, [userData])

  const [isOpenClicked, setIsOpenClicked] = useState(false);

  const onBottomIconClick = (isOpen) => {
    if (isOpen) {
      handleDrawerOpen();
    } else {
      handleDrawerClose();
    }
    setIsOpenClicked(isOpen);
  };

  return (
    <StyledDrawer
      variant={variant}
      open={isSidebarOpen}
      anchor='left'
      drawerwidth={drawerWidth}
      PaperProps={{ elevation: 3 }}
      onClose={(event, reason) => {
        handleDrawerClose(event, reason);
      }}
      onOpen={() => handleDrawerOpen()}
    >
      <StyledDrawerHeader>
        <StyledSiteLogoAndName needLogo needName isDark={isDark} size='full' />
      </StyledDrawerHeader>
      <Divider />
      {/* section for menu items */}
      <StyledMenu>
        <div style={{ width: '100%' }}>
          <CollapsibleMenu
            variant={variant}
            data={data}
            onBottomIconClick={onBottomIconClick}
            isOpenClicked={isOpenClicked}
            isSidebarOpenState={isSidebarOpen}
          />
        </div>

        {/* <List sx={{ width: '100%' }} component='nav'>
          {navOptions.map((navOption) => (
            <ListItem
              key={navOption.parent.name}
              navOption={navOption}
              open={isSidebarOpen}
            />
          ))}
        </List> */}
      </StyledMenu>
      <Divider />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          p: 2
        }}
      >
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <Grid item xs style={{ marginTop: '-4px' }}>
            {isSidebarOpen === true ? (
              <Stack direction='row'>
                <Typography variant='body1' align='center'>
                  Build version-
                </Typography>
                <StyledTypography variant='body1' align='center'>
                  {BUILD_VERSION}
                </StyledTypography>
              </Stack>
            ) : null}
          </Grid>
          <Grid item lg={isSidebarOpen ? 3 : 12} md={isSidebarOpen ? 3 : 12} xs>
            {isSidebarOpen ? (
              <IconButton
                color='inherit'
                onClick={() => onBottomIconClick(false)}
              >
                <KeyboardDoubleArrowLeftSharpIcon />
              </IconButton>
            ) : (
              <IconButton
                color='inherit'
                onClick={() => onBottomIconClick(true)}
              >
                <KeyboardDoubleArrowRightSharpIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Box>
    </StyledDrawer>
  );
}
